"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState, type ReactNode } from "react";

export function coreQueryKey(userId: string | undefined | null, ...parts: readonly unknown[]) {
  return ["core", userId ?? "", ...parts] as const;
}

let portalQueryClient: QueryClient | undefined;

export function getPortalQueryClient(): QueryClient | undefined {
  return portalQueryClient;
}

export async function clearPortalCache(client: QueryClient | undefined = portalQueryClient) {
  if (!client) return;
  await client.cancelQueries();
  client.clear();
}

export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { retry: false, staleTime: 5_000, gcTime: 10_000 } },
      }),
  );
  useEffect(() => {
    portalQueryClient = client;
    return () => {
      if (portalQueryClient === client) {
        portalQueryClient = undefined;
      }
    };
  }, [client]);
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
